import { render, staticRenderFns } from "./PathwaysView.vue?vue&type=template&id=5d06ac61&"
import script from "./PathwaysView.vue?vue&type=script&lang=js&"
export * from "./PathwaysView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports